import React, { useEffect } from 'react';
import './index.css';
import { ThemeProvider } from './ThemeContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Portfolio from './components/Portfolio';
import WhyChoose from './components/WhyChoose';
import CTA from './components/CTA';
import Careers from './components/Careers';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AnnouncementBar from './components/AnnouncementBar';
import SkipLink from './components/SkipLink';
import { FEATURES } from './config';

function App() {
  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash;
    window.requestAnimationFrame(() => {
      const el = document.querySelector(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    });
  }, []);

  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-brand-bg text-brand-text transition-colors duration-300">
        <SkipLink />
        {FEATURES.GPT5_ENABLED && (
          <AnnouncementBar message={FEATURES.GPT5_ANNOUNCEMENT} />
        )}
        <Navbar />
        <main id="main">
          <Hero />
          <About />
          <Services />
          <Products />
          <Portfolio />
          <WhyChoose />
          <CTA />
          <Careers />
          <Contact />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
